module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTW05-45Light.927655d4.woff";